import { useState } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { useThemeLoader } from '../../../Helpers/useThemeLoader';
import hamburger from '../../../../img/hamburger.svg';
import santisiLogo from '../../../../img/MainWebsite/santisiLogo.png';
import LoadingSpinner from '../Shared/LoadingSpinner';
import LocationNotFound from '../MainPages/LocationNotFound';


let Header = ({turnOffBackBtn}) => {
    const navigation = useNavigate();
    const { location } = useParams();

    const [showNavbar, setShowNavbar] = useState(false)
    
    // Use the optimized theme loader with loading state
    const { loading, locationName, isContactable, error } = useThemeLoader(location);


    let version = "v2";


    const handleShowNavbar = () => {
        setShowNavbar(!showNavbar)
    }

    // If there's an error loading the location, show the error page only
    if (error && !loading) {
        return <LocationNotFound locationId={location} />;
    }

    return (
        <div>
            {loading && <LoadingSpinner />}
            <nav className={'navbar'}>
                <div className='container'>
                    {/* Left: Logo/Back Button */}
                    <div className='navbar-left'>
                        {turnOffBackBtn ? (
                            // TODO: Update with backend pull for logo configuration per location/theme
                            locationName.toLowerCase() === "santisi brothers" ? (
                                <img src={santisiLogo} alt="location-logo" className='location-logo' />
                            ) : null
                        ) : (
                            <NavLink className='back-link' onClick={() => navigation(-1)}>
                                ← Back
                            </NavLink>
                        )}
                    </div>

                    {/* Center: Location Name */}
                    <div className='navbar-center'>
                        <h1>{locationName.toUpperCase()}</h1>
                    </div>

                    {/* Right: Navigation & Hamburger */}
                    <div className='navbar-right'>
                        <div className={`nav-elements  ${showNavbar && 'active'}`}>
                            <ul>
                                <li>
                                    <NavLink className='nav-link' to={`/${version}/${location}/`}>
                                        Menu
                                    </NavLink>
                                </li>
                               
                                <li>
                                    <NavLink className='nav-link' to={`/${version}/${location}/Sponsors`}>
                                        Sponsors
                                    </NavLink>
                                </li>
                                {isContactable
                                ?
                                <>
                                <li>
                                    <NavLink className='nav-link' to={`/${version}/${location}/CartRequest`}>
                                        Cart Request
                                    </NavLink>
                                </li>
                                </>
                                : <></>}
                                                                <li>
                                    <NavLink className='nav-link' to={`/${version}/${location}/ContactUs`}>
                                        Contact
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                        <div className="menu-icon" onClick={handleShowNavbar}>
                            <img className='hamburger-icon' alt={"menu-toggle"} src={hamburger} />
                        </div>
                    </div>
                </div>
            </nav>
        </div>

    );
}

export default Header;